import { IIdentifierString } from './general.interfaces';

export interface IFolderIdent {
    mailboxId: string;
    folderId: string;
}

export interface ISelectedFolder {
    id: string;
    name: string;
    parentId: string;
}

export interface ICreateFolder {
    mailboxId: string;
    parentFolderId: string;
    name: string;
}

export interface ICreateFolderResponse extends IIdentifierString {
    version: string;
}

export interface IDeleteFolder {
    trashed?: boolean;
    version: number;
}

export interface IUpdateFolder {
    folderId: string;
    mailboxId: string;
    name: string;
    parentId: string;
    version: number;
    folderType: string;
}

export interface IFolder {
    id: string;
    name: string;
    parentId: string;
    mailboxId: string;
    isActive: boolean;
    folderType: string;
    version: number;
}

export interface ISenderFolder {
    folderInfo: IFolder;
    originalRecords: Array<any>;
    folderRecords: Array<any>;
}
// folderType: "Inbox"
// id: "572d7dde-3f87-4509-899c-510981f6162c"
// isActive: true
// mailboxId: "ecc5c243-535c-41d2-aa51-b880d082f6a8"
// name: "Indbakke"
// parentId: "fd9222d2-6c83-4c60-9d60-731e1d3acfc3"
// version: 0

export interface IViewFolder extends IFolder {
    children: Array<IViewFolder>;
    level: number;
    showChildren: boolean;
}

export enum folderActions {
    MOVE_FOLDER = '1',
    DELETE_FOLDER = '2',
    RENAME_FOLDER = '3',
    CREATE_FOLDER = '4',
    ADD_MAIL_NOTE = '5',
}

export interface IUpdatedFoldersAction {
    action: updateViewFolder;
    folderId: string;
}

export enum updateViewFolder {
    default,
    byFolderId,
}

export enum virtualFoldersEnum {
    MORE_FOLDERS = '-2',
    DELETE_FOLDER = '-1',
    UNREAD_FOLDER = '0',
}
